import { memo } from 'react';

import { useFormik } from 'formik';
import { ChartLine } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { StatisticForm } from './form';

import css from './MainScreenStatistic.module.css';

import { mainScreenSettingsService } from 'v2/api/mainScreenSettingsService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { StatisticModel } from 'v2/types/StatisticModel';
import { handleHttpError } from 'v2/utils';

interface MainScreenStatisticProps {
  statistic: StatisticModel;
}

export const MainScreenStatistic = memo<MainScreenStatisticProps>(({ statistic }) => {
  const { trigger } = useSWRMutation('updateStatistic', mainScreenSettingsService.updateStatistic, {
    onSuccess: () => {
      toast.success('The statistic has been successfully updated');
    },
    onError: handleHttpError,
  });

  const formik = useFormik<StatisticForm>({
    initialValues: {
      totalPrizesAmount: statistic.totalPrizesAmount,
    },
    onSubmit: (values) => {
      trigger(values);
    },
  });

  return (
    <Card>
      <CardHeader className={css.mainScreenStatisticTitle} title="Statistic" icon={ChartLine} />

      <form className="form-group" onSubmit={formik.handleSubmit}>
        <TextField
          name="totalPrizesAmount"
          value={formik.values.totalPrizesAmount}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Prizes Paid"
          size="small"
        />

        <Button variant="contained" type="submit">
          Update
        </Button>
      </form>
    </Card>
  );
});

MainScreenStatistic.displayName = 'MainScreenStatistic';
